export class Facility {
  bookingType: string;
}
